import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, Text, TooltipHost, mergeStyleSets } from '@fluentui/react';
import ChartGauge from '../Chart/ChartGauge';
import { action_setBoardChartGaugeSelectedDataPoint } from '../../../../../../reducers/actions/KPI/actions';
import { useState } from 'react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

function OCR_CHART_DUMMY(props) {
  	const { t } = useTranslation();

    const { 
		inputParam_ReportMode = false,
		inputParam_ShowGauge = false,
    } = props;

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
	const [selectedGaugeDataPointIndex, setSelectedGaugeDataPointIndex] = useState(0);
	const [fired, setFired] = useState(false);
	
	const acronim_titles = {
		acronim_s1_real: { acronim: "S1-Real", text: t("data-lang-lbl-field-valueReal")},
		acronim_s1_valueGoalPercent: {acronim: "S1-GoalP", text: t("data-lang-lbl-field-valueGoalPercent")},
		acronim_s1_valueGoal: {acronim: "S1-Goal", text: t("data-lang-lbl-field-valueGoal")},
	}

	const _base = [
		{
			name: acronim_titles.acronim_s1_real.acronim,
			type: "column",
			data: [1524365,754236,941263]
		},
		{
			name: acronim_titles.acronim_s1_valueGoalPercent.acronim,
			type: "line",
			data: [524788,325489,845698]
		},
		{
			name: acronim_titles.acronim_s1_valueGoal.acronim,
			type: "line",
			data: [124587,547863,657159]
		}
	]

  	const listSeriesX = _base;

  	const listSerieTimeY = ['01/01/2024','12/01/2024', '05/02/2024'];
  
  	const _baseSerieNames = [
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#1F7BE8'
			},
			labels: {
				style: {
				colors: '#1F7BE8',
				}
			},
			tooltip: {
				enabled: true
			},
			title: {
				text: acronim_titles.acronim_s1_real.acronim,
				style: {
					color: '#1F7BE8',
				}
			}
		},
		{
			axisTicks: {
				show: true,
			},
			axisBorder: {
				show: true,
				color: '#000099'
			},
			opposite: true,
			title: {
				text: acronim_titles.acronim_s1_valueGoalPercent.acronim,
				style: {
					color: '#000099',
				}
			}   
		},
		{
			show: false,
			title: {
				text: acronim_titles.acronim_s1_valueGoal.acronim,
				style: {
					color: '#FF8000',
				}
			}
		}
	]

	const title = "KPI";
	const subtitle = t('data-lang-lbl-measurementunit');
	const chartRef = useRef(null);

	useEffect(() => {
		try {
			if (!fired) {
				setFired(true)
				setTimeout(() => {
					if (chartRef.current !== null) {
						const chart = chartRef.current.chart;
						//chart.toggleDataPointSelection(0, selectedGaugeDataPointIndex);
		
						chart.toggleSeries(acronim_titles.acronim_s1_valueGoalPercent.acronim)
						chart.toggleSeries(acronim_titles.acronim_s1_valueGoal.acronim)
					}
				}, "100");
			}
		} catch (error) {
			
		}
    }, []);

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
		  	marginBottom: 12,
		  	fontWeight: FontWeights.semilight,
		}
	});

	return  <>
				{
					<div className='px-3 h-100 d-flex' style={{opacity: ".4" }}>
						{
							inputParam_ShowGauge &&
								<ChartGauge
									inputParam_ComponentContent={{l_dataserie: [{l_vals:[{valueGoalPercent: 50, serieTimeStr: '01/01/2024', color: 'v'}]}]}}
									selectedGaugeDataPointIndex={0}
								/>
						}
						<Col>
							<ReactApexChart
								ref={chartRef}
								type="line"
								series={ listSeriesX }
								options={{
									title: {
										text: inputParam_ReportMode ? "" : title,
										align: 'center',
									},
									subtitle: {
										text: inputParam_ReportMode ? "" : subtitle,
										align: 'center',
									},
									colors: ['#1F7BE8', '#000099', '#FF8000'],
									chart: {
										height: 350,
										type: 'line',
										stacked: false,
										events: {
											dataPointSelection: (event, chartContext, config) => { 
												setTimeout(() => {
													//dispatch(action_setBoardChartGaugeSelectedDataPoint(config.dataPointIndex))
													setSelectedGaugeDataPointIndex(config.dataPointIndex);
												}, 10);
											}
										},
										toolbar: {
											tools: {
												customIcons: [{
													icon: `<i class="ms-Icon ms-Icon--FileComment" aria-hidden="true"></i>`,
													index: -1,
													title: t('data-lang-lbl-charttooltiplegend'),
													class: 'custom-legeng-chart',
													click: toggleIsCalloutVisible
												}]
											}
										}
									},
									dataLabels: {
										enabled: false
									},
									stroke: {
										width: [2, 2, 2],
										dashArray: [0, 0, 5]
									},
									xaxis: {
										categories: listSerieTimeY,
									},
									yaxis: _baseSerieNames,
									tooltip: {
										fixed: {
										enabled: true,
										position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
										offsetY: 30,
										offsetX: 60
										},
									},
									legend: {
										horizontalAlign: 'center',
										offsetX: 40
									},
									responsive: [{
										breakpoint: undefined,
										options: {},
									}]
								}}
								height={"100%"}
							/>
							{isCalloutVisible &&
								<Callout
									role="dialog"
									gapSpace={0}
									target={`.custom-legeng-chart`}
									onDismiss={toggleIsCalloutVisible}
									setInitialFocus
									className={styles.callout}
								>
									<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
									<Text className='pb-2' block variant="small">
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_real.acronim}:`}</b> {`${acronim_titles.acronim_s1_real.text}`}
											</Col>
										</Row>
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_valueGoal.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoal.text}`}
											</Col>
										</Row>
										<Row>
											<Col className='col-auto'>
												<b>{`${acronim_titles.acronim_s1_valueGoalPercent.acronim}:`}</b> {`${acronim_titles.acronim_s1_valueGoalPercent.text}`}
											</Col>
										</Row>
									</Text>
								</Callout>
							}
						</Col>
					</div>
				}
			</>
}

OCR_CHART_DUMMY.propTypes = {
  	inputParam_Height: PropTypes.number,
  	inputParam_ReportMode: PropTypes.bool,
};

export default OCR_CHART_DUMMY;